import { LogDestination, LogMessage } from './Logger';

export class ConsoleLogDestination implements LogDestination {
  log(entry: LogMessage) {
    const { level, message, timestamp, context } = entry;
    const formatted = `[${timestamp.toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })}] [${level}] ${message}`;

    switch (level) {
      case 'debug':
        context !== undefined ? console.debug(formatted, context) : console.debug(formatted);
        break;

      case 'info':
        context !== undefined ? console.info(formatted, context) : console.info(formatted);
        break;

      case 'warn':
        context !== undefined ? console.warn(formatted, context) : console.warn(formatted);
        break;

      case 'error':
        context !== undefined ? console.error(formatted, context) : console.error(formatted);
        break;

      default:
        context !== undefined ? console.log(formatted, context) : console.log(formatted);
    }
  }
}
